import {
    MIXPANEL_EVENT_PROPERTIES,
    UserStore,
    ReferrerStore,
    PagePathStore,
    SimpleStore,
} from '../../../shared/mixpanel';

const { PAGE_TYPE } = MIXPANEL_EVENT_PROPERTIES;

export default {
    user: new UserStore(),
    referrer: new ReferrerStore(),
    pagePath: new PagePathStore(),
    pageType: new SimpleStore<typeof PAGE_TYPE, string>(PAGE_TYPE),
};
